/**
 * ============================================================
 * Russian
 * ============================================================
 *
 * Translators:
 *
 * Sergey Kuznetsov <https://github.com/Amaimersion>
 * Patience Daur <https://github.com/patiencedaur>
 */

import { Monogatari } from './../monogatari';

Monogatari.translation('Русский', {
	'AdvanceHelp': 'Чтобы играть, нажимайте на пробел или на левую кнопку мыши.',
	'AllowPlayback': 'Включить звуковое сопровождение',
	'Audio': 'Звук',
	'AutoPlay': 'Авто',
	'AutoPlayButton': 'Включить авточтение',
	'AutoPlaySpeed': 'Скорость авточтения',

	'Back': 'Назад',
	'BackButton': 'Вернуться назад',

	'Cancel': 'Отмена',
	'Close': 'Закрыть',
	'Confirm': 'Вы действительно хотите выйти?',
	'Credits': 'Авторы',

	'Delete': 'Удалить',
	'DialogLogButton': 'Показать журнал диалогов',

	'FullScreen': 'Полный экран',

	'Gallery': 'Галерея',

	'Help': 'Помощь',
	'Hide': 'Скрыть',
	'HideButton': 'Скрыть текст',

	'iOSAudioWarning': 'Настройки звука не поддерживаются на iOS.',

	'KeyboardShortcuts': 'Горячие клавиши',

	'Language': 'Язык',
	'Load': 'Загрузить',
	'LoadAutoSaveSlots': 'Автосохранённые игры',
	'LoadButton': 'Открыть меню загрузки',
	'Loading': 'Загрузка',
	'LoadingMessage': 'Подождите, пожалуйста, игра загружается',
	'LoadSlots': 'Сохранённые игры',
	'LocalStorageWarning': 'Локальное хранилище недоступно в этом браузере.',
	'Log': 'Журнал',

	'Music': 'Громкость музыки',

	'NewContent': 'Доступно обновление, перезагрузите страницу',
	'NoSavedGames': 'Нет сохранённых игр',
	'NoAutoSavedGames': 'Нет автосохранённых игр',
	'NoDialogsAvailable': 'Нет диалогов. Диалоги будут появляться здесь по мере прохождения игры',

	'OrientationWarning': 'Чтобы играть, пожалуйста, поверните Ваше устройство',
	'Overwrite': 'Перезаписать',

	'QuickButtons': 'Кнопки быстрого меню',
	'QuickMenu': 'Быстрое меню',
	'Quit': 'Выйти',
	'QuitButton': 'Выйти из игры',

	'Resolution': 'Разрешение',

	'Save': 'Сохранить',
	'SaveButton': 'Открыть меню сохранения',
	'SaveInSlot': 'Сохранить',
	'Settings': 'Настройки',
	'SettingsButton': 'Открыть меню настроек',
	'Show': 'Показать',
	'Skip': 'Пропустить',
	'SkipButton': 'Автопереход',
	'SlotDeletion': 'Вы действительно хотите удалить это сохранение?',
	'SlotOverwrite': 'Вы действительно хотите перезаписать это сохранение?',
	'Sound': 'Громкость эффектов',
	'Start': 'Начать игру',
	'Stop': 'Стоп',

	'TextSpeed': 'Скорость текста',

	'Video': 'Громкость видео',
	'Voice': 'Громкость голоса',

	'Windowed': 'Оконный режим',
});